// extracted by mini-css-extract-plugin
module.exports = {"mainEntityDetails":"fQoh3"};